import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M2.183 10.197c-.566-.736-.85-1.104-.85-2.197s.284-1.46.85-2.197C3.316 4.333 5.213 2.667 8 2.667c2.788 0 4.685 1.666 5.817 3.136.566.737.85 1.104.85 2.197s-.284 1.46-.85 2.197c-1.132 1.47-3.029 3.136-5.817 3.136-2.788 0-4.685-1.666-5.816-3.136Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }